import { BaseEnum } from './BaseEnum';

export class CommunityResourceSpeciality extends BaseEnum {
  static HOME_HEALTH = 'HOME_HEALTH';

  static MLTC_LTSS = 'MLTC_LTSS';
}

export default CommunityResourceSpeciality;
